/* eslint-disable @typescript-eslint/no-var-requires */
import React, { FunctionComponent, MutableRefObject, useRef } from 'react';

import './animation012.less';
import ImgPoint from '../../../../../assets/animation_point.gif';

interface IAnimation012Item {
  line: string;
  icon: string;
  color: string;
  number: string;
  text: string;
}

interface IAnimation012Props {
  items: IAnimation012Item[];
  onCompleted: () => void;
}

const Animation012: FunctionComponent<IAnimation012Props> = ({
  items,
  onCompleted,
}) => {
  const crrRef = useRef() as MutableRefObject<HTMLDivElement>;
  const [play, setPlay] = React.useState(1);
  const [isPlayed, setIsPlayed] = React.useState(false);
  const startPlay = (next = 1) => {
    if (isPlayed) {
      return;
    }
    next += 1;
    setPlay(next);
    setIsPlayed(true);
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1200);
    } else {
      console.log('Animation012 onCompleted');
      onCompleted && onCompleted();
    }
  };
  const getImg = (img: string) =>
    require(`../../../../../assets/${img}`).default;
  return (
    <div ref={crrRef} className="animation012 component">
      <div className="animation012-content">
        <div className="background-line1" />
        <div className="background-line2" />
        {items.map((itm: IAnimation012Item, idx: number) => (
          <div
            key={idx}
            className={`animation012-item animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
            onClick={() => startPlay()}
            style={{
              width: `${(1 / items.length) * 100 * 2 - 4}%`,
            }}
          >
            <img
              className={`click-point ${play > 1 ? 'hide' : ''}`}
              src={ImgPoint}
              alt=""
            />
            {idx % 2 === 0 ? (
              <>
                <div
                  className="animation012-indicate-number"
                  style={{ color: itm.color }}
                >
                  <div className="number">{itm.number} </div>
                </div>

                <div
                  className={`animation012-line animation012-line-${idx + 1}`}
                >
                  <img src={getImg(itm.line)} alt="" />
                </div>

                <div
                  className="animation012-icon"
                  style={{ backgroundColor: itm.color }}
                >
                  <img src={getImg(itm.icon)} alt="" />
                </div>

                <div
                  className="animation012-text"
                  dangerouslySetInnerHTML={{ __html: itm.text }}
                />
              </>
            ) : (
              <>
                <div
                  className="animation012-text"
                  dangerouslySetInnerHTML={{ __html: itm.text }}
                />

                <div
                  className="animation012-icon"
                  style={{ backgroundColor: itm.color }}
                >
                  <img src={getImg(itm.icon)} alt="" />
                </div>

                <div
                  className={`animation012-line animation012-line-${idx + 1}`}
                >
                  <img src={getImg(itm.line)} alt="" />
                </div>

                <div
                  className="animation012-indicate-number"
                  style={{ color: itm.color }}
                >
                  <div className="number">{itm.number}</div>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Animation012;
